module.exports = __webpack_public_path__ + "img/two.53c1d92f.jpg";